import {
  actionTypes,
  deleteAttachmentFailure,
  deleteAttachmentSuccess,
  historyDetailFailure,
  historyDetailSuccess,
  historyFailure,
  historySuccess,
  saveAttachmentsFailure,
  saveAttachmentsSuccess,
  fetchCSVReqActionSuccess,
  fetchCSVReqActionFailure,
  retryRequestActionSuccess,
  retryRequestActionFailure,
} from "./actions";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { IRequestItemRow } from "../../../models/Request";
import {
  fetchCsvHistoryRequest,
  fetchHistoryDetail,
  fetchHistoryRequest,
  retryRequestService,
} from "./services";

import {
  deleteAttachments,
  saveRequestAttachments,
} from "../../../common/ManualsUtils/ManualsServices";

const fetchHistoryRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.HISTORY_REQUEST),
    mergeMap((action: any) =>
      fetchHistoryRequest(action.payload).pipe(
        map((response: IRequestItemRow[]) => historySuccess(response)),
        catchError((error: any) => of(historyFailure(error)))
      )
    )
  );

const retryHistoryRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RETRY_REQUEST),
    mergeMap((action: any) =>
      retryRequestService(action.payload).pipe(
        map((response: any) => retryRequestActionSuccess(response)),
        catchError((error: any) => of(retryRequestActionFailure(error)))
      )
    )
  );

const fetchCSVHistoryRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_CSV_REQUEST),
    mergeMap((action: any) =>
      fetchCsvHistoryRequest(action.payload).pipe(
        map((response: IRequestItemRow[]) =>
          fetchCSVReqActionSuccess(response)
        ),
        catchError((error: any) => of(fetchCSVReqActionFailure(error)))
      )
    )
  );

export const fetchHistoryDetailEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.HISTORY_DETAIL),
    mergeMap((action: any) =>
      fetchHistoryDetail(action.id).pipe(
        map((response: any) => historyDetailSuccess(response)),
        catchError((error: any) => of(historyDetailFailure(error)))
      )
    )
  );

export const fetchDeleteAttachment = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_ATTACHMENT),
    mergeMap((action: any) =>
      deleteAttachments(action.id).pipe(
        map((response: any) => deleteAttachmentSuccess(response)),
        catchError((error: any) => {
          return of(deleteAttachmentFailure(error));
        })
      )
    )
  );

export const fetchSaveAttachments = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SAVE_ATTACHMENTS),
    mergeMap((action: any) =>
      saveRequestAttachments(action.id, action.files).pipe(
        map((response: any) => saveAttachmentsSuccess(response)),
        catchError((error: any) => {
          return of(saveAttachmentsFailure(error));
        })
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  fetchHistoryRequestsEpic,
  fetchHistoryDetailEpic,
  fetchDeleteAttachment,
  fetchSaveAttachments,
  fetchCSVHistoryRequestsEpic,
  retryHistoryRequestsEpic,
];
